// The following is for production only
export const environment = {
  production: true,
  baseUrl: 'https://odptaxonomy.com',
  loginUrl: 'account/login',
  idleTimeLogout: 1800000, // milliseconds
  timeToIdleWarning: 300000 // milliseconds
};
